import React, { HTMLInputTypeAttribute, useState } from "react";
import { Caption } from "../Typo/Caption";
import { StyledTextInput, Label, Field } from "../Styles/StyledTextInput";

interface TextInputProps {
  type: HTMLInputTypeAttribute;
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error: string;
}

const TextInput = ({
  type,
  id,
  name,
  label,
  onChange,
  value,
  error,
}: TextInputProps) => {
  return (
    <StyledTextInput>
      <Label htmlFor={id}>{label}</Label>
      <Field
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={(e) => onChange(e)}
      />
      {error && <Caption>{error}</Caption>}
    </StyledTextInput>
  );
};

export default TextInput;
